var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('div',{staticClass:"panel panel-default country-select-panel",staticStyle:{"border":"none","border-radius":"10px"}},[_c('div',{staticClass:"panel-body"},[_c('h1',[_vm._v("403")]),_c('br'),_c('h4',[_vm._v("Access to requested resource is denied")])])])])])
}]

export { render, staticRenderFns }